export default Object.freeze({
    // 契約書類型
    DATA_CONTRACT_TYPES: [
        {id: 1, name: '秘密保持契約'},
        {id: 2, name: '業務委託契約'},
        {id: 3, name: 'システム開発契約'},
    ],
    DATA_POSITIONS: {
        // 立場
        positions: [
            {id: 1, name: '委託側', has_contract: true},
            {id: 2, name: '受託側', has_contract: true},
            {id: 3, name: '表示されない', has_contract: false},
        ],
        // 契約書の特徴1
        first_search_conditions: [
            {id: 1, name: 'AI', has_contract: true},
            {id: 2, name: 'アプリ', has_contract: true},
            {id: 3, name: 'アジャイル', has_contract: true},
            {id: 4, name: 'オフショア', has_contract: true},
            {id: 5, name: '請負', has_contract: true},
            {id: 6, name: '表示されない', has_contract: false},
            {id: 7, name: '準委任型', has_contract: true},
            {id: 8, name: '混合型', has_contract: true},
        ],
    },
    // 契約書の特徴2
    DATA_SECOND_SEARCH_CONDITIONS: [
        {
            id: 1,
            name: '1,000万～1億',
            contract_titles: [
                {id: 11, name: '契約書タイトル11'},
                {id: 12, name: '契約書タイトル12'},
                {id: 13, name: '契約書タイトル13'},
            ],
        },
        {
            id: 2,
            name: 'B 株式会社',
            contract_titles: [
                {id: 21, name: '契約書タイトル21'},
                {id: 22, name: '契約書タイトル22'},
            ],
        },
        {
            id: 3,
            name: '担当者 A 案件',
            contract_titles: [
                {id: 31, name: '契約書タイトル31'},
                {id: 32, name: '契約書タイトル32'},
            ],
        },
        {
            id: 4,
            name: 'C 株式会社',
            contract_titles: [
                {id: 41, name: '契約書タイトル41'},
            ],
        },
        {
            id: 5,
            name: 'ライセンス型',
            contract_titles: [
                {id: 51, name: '契約書タイトル51'},
                {id: 52, name: '契約書タイトル52'},
            ],
        },
        {
            id: 6,
            name: '権利移転型',
            contract_titles: [
                {id: 61, name: '契約書タイトル61'},
                {id: 62, name: '契約書タイトル62'},
            ],
        },
        {
            id: 7,
            name: 'ウォーターフォール型',
            contract_titles: [
                {id: 71, name: '契約書タイトル71'},
            ],
        },
        {
            id: 8,
            name: 'アジャイル型',
            contract_titles: [
                {id: 81, name: '契約書タイトル81'},
                {id: 82, name: '契約書タイトル82'},
            ],
        },
    ],
    // 不足条文
    DATA_SEARCH_RESULT_REQUIRED_ARTICLES: [
        {
            check_required_flg: false,
            line_no: -1,
            sort_order: 0,
            article_label: 'aaaaaaaaaaaaaaaaa',
            delete_required_flg: false,
            article_title: '第4条（資料等の提供）',
            article_body: '１．甲は、乙の求めがあるときは、本業務の遂行に関連する資料又は情報（以下「資料等」という。）を提供するものとし、合理的理由がない限りこれを拒んではならない。\n2．乙は、前項の資料等を善良なる管理者の注意をもって管理するものとする。\n3．乙は、契約終了時に資料等を返却又は破棄する。',
            one_phrase_comment: '原則：資料提供は拒絶理由に制限',
            memo: '■趣旨\n資料等の提供が適切・適時になされない場合、開発遅延が生じうるので、合理的理由ない限り提供する義務にする\n\n■交渉コメント\n開発遅延を防ぐためにも、資料提供については合理的理由がない限り義務とさせてください\n\n■追記後の交渉方針\n3項に関し、返還・破棄の具体的方法（復元不可な方法など）の指定まで要求されるカウンターが来た場合は、削除する\n\n※過去事例（●●●●●社との取引事例） 破棄について厳格な破棄方法を指定されたため、破棄だけのために多大なコストが発生した',
        },
    ],
    // 類似条文
    DATA_SEARCH_RESULT_SIMILAR_ARTICLES: [
        // （表明及び保証）
        {
            check_required_flg: false,
            index: 100,
            line_no: 43,
            sort_order: 1,
            article_label: '',
            delete_required_flg: true,
            article_title: '（表明及び保証）',
            article_body: '乙は、成果物が仕様に定めた品質及び内容に合致するものであること、本業務の遂行に際し、甲及び第三者の権利（知的財産権及び生命、身体又は財産に係る権利を含む。）を侵害しないこと、本業務の遂行に関して不正競争防止法上の問題が発生しないことはもちろん、甲が想定する利用目的に適合すること、成果物が通常期待される品質、安全性、完全性を有していることを保証する。',
            one_phrase_comment: 'or：知り得る限り保証するも可',
            memo: '■趣旨\n仕様等に明記されないもの、自社では知り得ないもの、調査に負担がかかるものなどは保証内容から除くこと。\n\n■修正理由\n過剰な表明保証は、そのための過大な調査コストが生じてしまい本報酬額が妥当性を失うことになるため、緩和の方向で修正する。',
        },
        // （違約金）
        {
            check_required_flg: false,
            index: 101,
            line_no: 85,
            sort_order: 2,
            article_label: '',
            delete_required_flg: true,
            article_title: '（違約金）',
            article_body: '甲および乙は、自らが本契約に違反した場合、相手方に対し金●●万円の違約金を支払うものとする。',
            one_phrase_comment: '要削除',
            memo: '■削除理由\n相手方に損害が生じたか否かに関わらず支払うため、金額の根拠が不明確。\n違約金の支払いは本契約について１度きりなのか、違反があるごとに何度でも支払うのか等紛争になりやすい。',
        },
        // 第1条 （目的及び適用範囲）
        {
            check_required_flg: false,
            index: 102,
            line_no: 4,
            sort_order: 3,
            article_label: '目的及び適用範囲',
            delete_required_flg: false,
            article_title: '第1条 （目的及び適用範囲）',
            article_body: '１ 本契約は、本件業務を適正かつ確実に遂行するため、甲乙の権利及び義務の基本的な契約事項を定めることを目的とする。\n２ 本契約は、個別契約に適用される。但し、個別契約の内容と本契約の内容が異なる場合には、当該個別契約の定めが優先する。',
            one_phrase_comment: '必須：個別契約優先',
            memo: '■注意\n本契約より個別契約を優先することを明記すること\n\n※過去事例\n株式会社●●との契約で基本契約が優先されていたため、特別な取り決めのある業務に関し個別契約を締結できず別途契約となり、先方法務部との契約交渉に時間がかかってしまった。',
        },
        // 第２条（委託業務）
        {
            check_required_flg: false,
            index: 103,
            line_no: 8,
            sort_order: 4,
            article_label: '委託業務',
            delete_required_flg: false,
            article_title: '第２条（委託業務）',
            article_body: '１ 甲は、乙に対し、ソフトウェア開発業務並びにこれらに付随関連する業務（以下「本件業務」という。）を委託し、乙はこれを受託する。\n２ 本件業務は、請負型業務及び準委任型業務から成るものとし、各個別業務の内容及び契約形態は、次条で定める個別契約において定めるものとする。',
            one_phrase_comment: '包括内容に注意',
            memo: '■包括内容\n業務内容に「本件業務の遂行に付随する業務」などの記載がある場合、想定外の業務を委託される可能性がある。\n\n■手当\n・包括的な内容を削除する。\n・具体的な業務内容を列挙する。\n・業務範囲外の作業を列挙する。\n・（本契約の変更が困難な場合）個別契約の締結時に注意する。',
        },
        // 第３条（個別契約の成立）
        {
            check_required_flg: false,
            index: 104,
            line_no: 12,
            sort_order: 5,
            article_label: '個別契約の成立',
            delete_required_flg: false,
            article_title: '第３条（個別契約の成立）',
            article_body: '１ 個別契約は、甲が乙に対し、注文書又は発注書による申し込みを行い、乙がこれを注文請書によって承諾することによって成立する。\n２ 前項に定める個別契約は、以下各号に定める取引条件を定めるものとする。\n(1)\t本件業務の内容（以下「本件仕様」という。）\n(2)\t納入期限\n(3)\t納入すべき物件の明細及び納入場所\n(4)\t本件業務の対価及びその支払方法\n(5)\tその他本件業務遂行に必要な事項',
            one_phrase_comment: '必須：簡易的な方法',
            memo: '■趣旨\n個別契約は双方押印の契約のみならず、注文書やWEB発注等簡易な方法を記載する。\n\n■法務→事業部\n個別契約が双方押印の場合、印紙税がかかる場合があるので要確認。',
        },
        // 第5条（業務に関する責任）
        {
            check_required_flg: false,
            index: 105,
            line_no: 21,
            sort_order: 6,
            article_label: '業務に関する責任',
            delete_required_flg: false,
            article_title: '第5条（業務に関する責任）',
            article_body: '甲及び乙は、個別契約において、本件業務の準委任型又は請負型の区別について定めるものとし、乙は当該定めに従い次の通り本件業務を遂行するものとする。なお、本契約又は個別契約に別段の定めをした場合は当該定めによるものとする。\n(1)\t準委任型の場合は、善良な管理者の注意をもって委託業務を遂行する義務を負い、納入物を完成させる義務を負うものではない。\n(2)\t請負型の場合は、業務仕様書に適合する納入物を完成させる義務を負うものとする。',
            one_phrase_comment: '個別契約の定めを確認すること',
            memo: '■法務→事業部\n通常は、要件定義は準委任、外部設計はどちらもありえる、実開発は請負、運用テスト等は準委任とすることが多い。\n個別契約締結時に確認すること。',
        },
        // 第6条（納入）
        {
            check_required_flg: true,
            index: 106,
            line_no: 28,
            sort_order: 9,
            article_label: '納入',
            delete_required_flg: false,
            article_title: '第6条（納入）',
            article_body: '1．乙は甲に対し、本件業務遂行の結果生じる成果物（以下、「本件成果物」という。）について、個別契約において定める納入期限までに、個別契約において定める場所及び方法により、当該成果物を納入するものとする。\n2．本件成果物の所有権、知的財産権その他の権利は、次条の検査完了時に移転するものとする。',
            one_phrase_comment: '所有権の移転時期：検査合格後（第2案あり）',
            memo: '■権利移転時期\n報酬支払を確保するならば、権利の移転時期は「報酬の完済時」に変更する\n\n■法務⇒事業部\n納入期限と納入方法については都度個別契約の規定をしっかり確認させるようにする',
        },
        // 第7条（成果物の検査）
        {
            check_required_flg: true,
            index: 107,
            line_no: 34,
            sort_order: 10,
            article_label: '成果物の検査',
            delete_required_flg: false,
            article_title: '第7条（成果物の検査）',
            article_body: '1.甲は、本件成果物の納入がなされた日から5営業日以内（以下、「検査期間」という。）に、当該本件成果物の検査を実施しなければならない。\n2.本件成果物が前項の検査に適合しない場合、甲は乙に対し適合しない具体的な理由を明示した書面により不合格の通知をするものとする。この場合、乙は、甲と協議のうえ定めた期限内に本件成果物を修正して甲に納入し、甲は、検査期間において、所定の検査を再度行うものとする。\n3.甲が検収結果を交付しない場合であっても、検査期間内に甲が書面で具体的な理由を明示して不適合の通知をしない場合には、本件成果物は、検査期間の経過時点をもって本条所定の検査に合格したものみなす。',
            one_phrase_comment: '必須：みなし合格の規定',
            memo: '■法務⇒事業部\n検査期間がどの程度なら適切かについては、開発担当者などに逐一確認\n■要修正\n補修期間が「委託者指定期間」になる場合は要修正\n■手当て\n何度も補修を求められそうな案件では、補修限度回数を設定するなど手当を入れる\n※過去事例（▲▲▲社との取引事例）\n　数十回の軽微な補修依頼が多発し、結果的に大きなコストとなった',
        },
        // 第8条（危険負担）
        {
            check_required_flg: true,
            index: 108,
            line_no: 31,
            sort_order: 11,
            article_label: '危険負担',
            delete_required_flg: false,
            article_title: '第8条（危険負担）',
            article_body: '本件成果物の滅失、毀損等の危険負担は、納入前については甲の責によるものを除き乙が、納入後については乙の責によるものを除き甲が、それぞれ負担する。',
            one_phrase_comment: '納入前後で危険負担を移転（第2案あり）',
            memo: '■趣旨\n納入後は成果物が自社の管理下になく、成果物に何かあっても状況を把握できないため、納入前後を基準とするのが望ましい。',
        },
        // 第9条（瑕疵担保責任）
        {
            check_required_flg: true,
            index: 109,
            line_no: 40,
            sort_order: 12,
            article_label: '瑕疵担保責任',
            delete_required_flg: false,
            article_title: '第9条（瑕疵担保責任）',
            article_body: '１ 本件成果物の検収完了後６か月以内に、検査では発見できなかった本件仕様との不一致（以下、「瑕疵」という。）が発見された場合、甲は乙に対して当該瑕疵の修正を請求することができる。\n２ 前項の規定は、当該瑕疵が甲の指示又は甲が提供した資料等に起因する場合には適用しない。',
            one_phrase_comment: '必須：相手方の指示等に起因する場合の免責（第2案あり）',
            memo: '■趣旨\n相手方の指示、仕様、相手方の資料等に従った以上、自社には落ち度がないので、それらに起因する本件成果物の瑕疵は免責とすること。\n\n■瑕疵担保期間\n瑕疵担保期間は6ヶ月で譲歩不可。\n\n■要注意\n「瑕疵」の定義について、細かなバグや不具合が含まれているかについては要注意。',
        },
        {
            check_required_flg: true,
            index: 110,
            line_no: 49,
            sort_order: 13,
            article_label: '委託料',
            delete_required_flg: false,
            article_title: '第10条（委託料）',
            article_body: '１ 甲は、個別契約の定めに従い、乙に対し委託料を支払うものとする。\n２ 前項の委託料の振込手数料は、甲の負担とする。',
            one_phrase_comment: '費用について確認',
            memo: '■法務→事業部\n当社側で負担となる費用の定めがないか確認。\n・知財などの権利移転の費用\n・本件成果物の梱包費用、運送費用\n・その他委託料に含まれるもの\n・振込手数料',
        },
        {
            check_required_flg: true,
            index: 111,
            line_no: 53,
            sort_order: 14,
            article_label: '知的財産権等',
            delete_required_flg: false,
            article_title: '第11条（知的財産権等）',
            article_body: '１ 本件業務遂行の過程で生じた発明その他の知的財産（以下、総称して「発明等」という）に係る知的財産権（著作権（著作権法第２７条及び第２８条の権利を含む。）、特許権、実用新案権、商標権、意匠権その他の知的財産権（それらの権利を取得し、又はそれらの権利につき登録等を出願する権利を含む。）をいい、以下同様とする。）は、次項において定める本件成果物に関するものを除き、すべて乙に帰属するものとする。\n２ 本件成果物にかかる知的財産権（本件業務遂行開始前から乙に帰属していた知的財産権を除く。）は、汎用的な利用が可能なプログラム等の著作権を除き、第１０条に基づく委託料支払完了と同時に、甲に帰属又は移転するものとし、当該移転の対価は、委託料に含まれるものとする。\n３ 本条に基づき甲に帰属した権利について、乙は、著作者人格権を行使しないものとする。',
            one_phrase_comment: '必須：従前保有権利と汎用利用権利を留保',
            memo: '■要注意\n従前より自社が保有する権利と汎用的に利用可能なプログラム等に関する権利まで相手方へ移転していないかは必ず確認し、仮に移転するとされていた場合、必ず雛型規定に修正。\n\n■修正理由\n自社保有権利と汎用性のあるものに関する権利まで移転すると、以後の事業運営において大きな支障となりるため、留保する。\n※仮に完全な独占権利を先方が主張する場合は、報酬額の相当性の再検討となる。\n\n■侵害時の対応\n権利侵害があった時の対応が記載されている場合は、相手方の指示、仕様、資料等に基づく場合を免責とする内容を追記すること。',
        },
        {
            check_required_flg: true,
            index: 112,
            line_no: 58,
            sort_order: 15,
            article_label: '秘密保持義務',
            delete_required_flg: false,
            article_title: '第12条（秘密保持義務）',
            article_body: '１ 甲及び乙は、相手方から開示を受け又は知り得た相手方の営業上・技術上又はその他一切の業務上の情報のうち、秘密である旨を明示されたもの（以下「秘密情報」という。）について、秘密として保管・管理しなければならない。ただし、次の各号のいずれか一つに該当する情報については秘密情報に含まれない。\n(1)        開示を受ける前に既に保有していた情報\n(2)        開示のときに既に公知であった情報\n(3)        開示後被開示当事者の責によらず、公知となった情報\n(4)        秘密保持義務を負うことなく第三者から正当に入手した情報\n(5)        相手方から提供を受けた情報によらず、独自に開発又は創作した情報\n２ 甲及び乙は、秘密情報について、本契約の目的の範囲内でのみ使用するものとし、本契約の目的に必要な範囲内でのみ複製するものとする。',
            one_phrase_comment: '必須：双方義務（第2案あり）',
            memo: '■手当\n当社のみの義務となっていることが多いため、双方義務とすること。\n当社にとって負担となる管理義務が課されている場合は修正すること。\n秘密情報の除外規定に、独自開発を必ず入れること。',
        },
        {
            check_required_flg: true,
            index: 113,
            line_no: 66,
            sort_order: 16,
            article_label: '再委託',
            delete_required_flg: false,
            article_title: '第13条（再委託）',
            article_body: '乙は、本件業務の遂行に必要となる場合、本件業務の全部又は一部を第三者に再委託することができる。この場合、乙は、当該第三者の選任及び監督につき、甲に対して責任を負う。',
            one_phrase_comment: '再委託の可否確認（第2案あり）',
            memo: '■法務→事業部\n再委託する可能性がある場合は、再委託が可能になるよう変更すること。',
        },
        {
            check_required_flg: true,
            index: 114,
            line_no: 68,
            sort_order: 17,
            article_label: '解除',
            delete_required_flg: false,
            article_title: '第14条（解除）',
            article_body: '１ 甲又は乙は、一方の当事者が、下記各号の一に当たる場合は、事前の通知等なく、本契約又は個別契約の全部又は一部を解除することができる。\n(1)        本契約及び個別契約に定める条項につき重大な違反があったとき\n(2)        支払停止若しくは支払不能となり、又は破産手続開始、民事再生手続開始、会社更生手続開始、特別清算開始若しくはこれらに類する手続開始の申立てがあった場合\n(3)        自ら振出し若しくは引き受けた手形又は小切手が１通でも不渡りの処分を受けた場合\n(4)        差押、仮差押、仮処分、強制執行又は競売の申立てがあった場合\n(5)        租税公課の滞納処分を受けた場合\n(6)        金融機関から取引停止の処分を受けたとき\n(7)        財産状態が悪化し又は悪化するおそれがあると認められる相当の事由があるとき\n(8)        解散、会社分割、事業譲渡又は合併の決議をしたとき\n２ 前項の規定に関わらず、一方当事者が本契約の条項の一つに違反したときは、当該違反の是正を催告するものとし、催告から7営業日が経過してもなお是正されない場合には、本契約を解除することができる。\n３ 本条に基づく解除は、甲に対する損害賠償請求権の行使を妨げない。',
            one_phrase_comment: '自社から解除可能か否か確認',
            memo: '■自社からの解除\n解除が相手方からのみになっている場合は、自社からも解除できるように変更すること。\n\n■要注意\n無催告解除事由に「契約を維持できない重大な事由」「継続できない重大な事由」「信頼関係が破壊された場合」などといった広範囲に該当しうる事由が規定されている場合は、必ず削除すること（∵受託者の方が解除のリスクをより負う）。',
        },
        {
            check_required_flg: false,
            index: 115,
            line_no: -1,
            sort_order: 18,
            article_label: '不可抗力',
            delete_required_flg: false,
            article_title: '第15条（不可抗力）',
            article_body: '１　甲及び乙は、地震・台風・津波・その他の天変地異、並びに戦争・暴動・内乱・政府・地方公共団体の命令規制、及び法令の改正など当事者の責めに帰すことのできない事情（以下「不可抗力」という。）により本契約又は個別契約の全部、若しくは一部が履行不能又は履行遅滞となった場合、相手方に対しその責任を負わないものとする。\n２　前項の不可抗力が発生し、自己の債務が履行不能又は履行遅滞になるおそれがある場合には、直ちに相手方に書面をもって通知する。',
            one_phrase_comment: '確認：双務であることを確認',
            memo: '■確認\n不可抗力の範囲をなるべく広くすること。\n（当社が受託者のため、業務遂行が不能となった場合免責される範囲を広くするため）',
        },
        {
            check_required_flg: true,
            index: 116,
            line_no: 82,
            sort_order: 19,
            article_label: '損害賠償',
            delete_required_flg: false,
            article_title: '第16条（損害賠償）',
            article_body: '甲及び乙は、本契約に基づき又は関連して、相手方の責に帰すべき事由により損害を被った場合、相手方に対し、現実に生じた直接かつ通常の範囲の損害（弁護士費用その他専門家費用及び逸失利益を除く。）の賠償を請求することができる。なお、当該賠償額は、当該賠償の原因を生じさせた個別契約において定めた委託報酬額を上限とする。',
            one_phrase_comment: '原則譲歩不可（第2案あり）',
            memo: '■損賠の範囲\n現実に生じた直接かつ通常の範囲に限ること、弁護士費用及び逸失利益は必ず除くこと。\n\n■損賠の上限額\n必ず委託報酬額を上限とすること。なお、基本契約すべての委託報酬総額が上限となるかのような規定にならないよう「当該賠償額は、当該賠償の原因を生じさせた個別契約において定めた委託報酬額」と明記することを忘れないようにする。',
        },
        {
            check_required_flg: false,
            index: 117,
            line_no: 88,
            sort_order: 20,
            article_label: '権利譲渡の制限',
            delete_required_flg: false,
            article_title: '第17条（権利譲渡の制限）',
            article_body: '甲及び乙は、相手方の書面による事前の承諾なく、本契約上の地位又は本契約に基づく権利義務の全部又は一部を、第三者に譲渡し又は担保の目的に供してはならない。',
            one_phrase_comment: '必須：双方義務',
            memo: '■趣旨\n権利を譲渡する場合は、双方とも相手方の承諾を必須とする。\n\n■過去事例：C社\n本条がなかったため、相手方が事業を分割した際に通知をもらえず、秘密情報が第三者へ譲渡されていた。',
        },
        {
            check_required_flg: false,
            index: 118,
            line_no: 91,
            sort_order: 21,
            article_label: '契約期間',
            delete_required_flg: false,
            article_title: '第18条（契約期間）',
            article_body: '１ 本契約の有効期間は、本契約締結の日から●年間とする。但し、期間満了の●ヶ月前までに甲乙いずれからも何らの書面による申出がないときは、本契約は、同条件で更に同期間継続されるものとし、その後も同様とする。\n２ 前項にかかわらず、乙は、●ヶ月前までに書面で通知することにより、いつでも本契約を解除することができる。',
            one_phrase_comment: '更新の要否確認',
            memo: '■法務→事業部\n本契約は基本契約なので1年ごとの自動更新が一般的だが、相手方に応じて更新しないことも可能。\n\n※過去事例\n株式会社●●（自社にとって不利な条件だったため、1年間で契約終了とした）、株式会社●●（委託内容が明確だったため、3年で終了するようにした）、株式会社●●（事業譲渡予定だと聞いたので、契約終了日を譲渡前とした）',
        },
        // 第19条（存続条項）
        {
            check_required_flg: false,
            index: 119,
            line_no: 95,
            sort_order: 22,
            article_label: '存続条項',
            delete_required_flg: false,
            article_title: '第19条（存続条項）',
            article_body: '第●条、第●条、第●条及び条項の性質に鑑み当然に存続すべき規定は、期間満了、解除、失効、その他理由の如何を問わず本契約が終了したあともその効力を存続する。なお、第●条、第●条及び第●条は、本契約終了後●年間存続するものとする。',
            one_phrase_comment: '必須：存続期間の定め',
            memo: '■趣旨\n保証条項、瑕疵担保責任、秘密保持義務、資料の保管義務等、永久に存続することで当社の負担になる条項があれば、存続期間を定めること。\n契約終了後3〜5年が目安。',
        },
        // 第20条（管轄裁判所）
        {
            check_required_flg: false,
            index: 120,
            line_no: 100,
            sort_order: 23,
            article_label: '管轄裁判所',
            delete_required_flg: false,
            article_title: '第20条（管轄裁判所）',
            article_body: '本契約に起因し又は関連する一切の紛争については、その訴額に応じ、東京地方裁判所又は東京簡易裁判所を第一審の専属的合意管轄裁判所とする。',
            one_phrase_comment: '必須：東京（第2案あり）',
            memo: '■趣旨\n合意管轄は自社本社のある東京とすること。\nまたは、受託者である自社が被告となる可能性が高いので、「被告となる当事者の本社所在地を管轄する地方裁判所」でも可。',
        },
        // 第21条（協議）
        {
            check_required_flg: false,
            index: 121,
            line_no: 98,
            sort_order: 24,
            article_label: '協議',
            delete_required_flg: false,
            article_title: '第21条（協議）',
            article_body: '本契約に関し疑義が生じた場合又は本契約に定めなき事由が生じた場合は、甲乙協議のうえ速やかに解決を図るものとする。',
            one_phrase_comment: '協議不調の定めに注意',
            memo: '■趣旨\n協議が調わなかった場合の定めがある場合は要確認。\n解除の定めがある場合が多いが、解除権が相手方のみとなる場合や仕掛品の納入が定められている場合は削除。',
        },
    ],
    // 条文例をもっと見る
    DATA_SEE_MORE_ARTICLES: {
        // 念の為、A～Z社まで入れています
        suppliers: ['A社', 'B社', 'C社', 'D社', 'E社', 'F社', 'G社', 'H社', 'I社', 'J社', 'K社', 'L社', 'M社', 'N社', 'O社', 'P社', 'Q社', 'R社', 'S社', 'T社', 'U社', 'V社', 'W社', 'X社', 'Y社', 'Z社'],
        articles: [
            // article_label：目的及び適用範囲
            {
                article_id: 1,
                index: 'disp_gva_sample',
                contract_id: 15,
                sort_order: 2,
                article_title: '第1条（適用）',
                article_body: '1.本契約は、甲が乙に業務（以下「対象業務」という。）を委託するにあたり、甲乙間で締結される契約（以下「個別契約」という。）に適用されることとします。\n' +
                    '2.本契約と個別契約の定めが異なる場合は、本契約の定めが優先して適用されるものとします。',
                article_label: '目的及び適用範囲',
                one_phrase_comment: '必須：本契約優先',
                memo: '■事業部向けコメント\n①自社雛形を変更なしで締結する場合は本契約を優先させること（個別契約で先方要望を有効としないようにするため）\n②自社雛形を変更する場合は法務部判断',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: '',
                date_of_conclusion: '',
            },
            // article_label：委託業務
            {
                article_id: 2,
                index: 'disp_gva_sample',
                contract_id: 21,
                sort_order: 2,
                article_title: '第1条（目的）',
                article_body: '本契約は、甲が使用する乙製〇〇システムおよび〇〇システム（以下、併せて本システムという）に関し、甲が次に定める業務（以下、本件業務という）を乙へ委託し、乙がこれを受託するにあたりその取扱いについて定めるものである。\n（1）        課題管理業務\n（2）        運用サポート業務（インストレーションサポートを含む運用サポート、およびソフトウェア不具合解析）\n（3）        メンテナンス監視業務（保守業務は含まれない）',
                article_label: '委託業務',
                one_phrase_comment: '必須：具体的な業務の明記',
                memo: '■必須\n・受託する業務の内容を明確に規定すること\n・業務に含まれるもの、含まれないものを明確に記載すること',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: 'A社',
                date_of_conclusion: '20150825',
            },
            // article_label：委託業務
            {
                article_id: 3,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '第3条（業務内容）',
                article_body: '1 委託者が受託者に委託し、受託者が受託する業務の詳細は、別紙1に定めるものとする。\n2 受託者は、本契約及び別紙1定める内容に従い、業務を遂行するものとする。',
                article_label: '委託業務',
                one_phrase_comment: '要確認：別紙 / 具体的な業務内容、仕様等が定められていること',
                memo: '■確認ポイント\n別紙に業務内容、詳細仕様、作業期間、納期、報告の有無などの記載があることを確認する。',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: '',
                date_of_conclusion: '',
            },
            // article_label：個別契約の成立
            {
                article_id: 4,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '第4条（個別契約の成立）',
                article_body: '1        個別契約は、委託者が受託者と協議の上決定した書式の注文書（電磁的方法を含む。以下同じ。）により発注し、受託者がこれを承諾することによって成立する。\n2        受託者は、委託者の発注内容に疑義又は異議がある場合、注文書受領後7営業日以内に委託者にその旨通知する。',
                article_label: '個別契約の成立',
                one_phrase_comment: '確認：成立時期',
                memo: '◼確認ポイント\n成立時期：「委託者が注文書を交付したとき」「受託者が注文書を受領した時」の場合、受託者は拒否、変更ができない\n\n■妥協案\n注文書に対する諾否の回答時期について「7営業日以内」としているが、先方より短縮の依頼があった場合、事業部と相談の上「3営業日以内」まで短縮可（7→5→3の順で短縮すること）。',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: '',
                date_of_conclusion: '',
            },
            // article_label：個別契約の成立
            {
                article_id: 4,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '第3条（個別契約）',
                article_body: '1.        個別契約は、甲が発注年月日、本業務の内容、仕様、数量、納期、納入場所、納入条件、単価、契約代金等の本契約に定めのない注文内容を記載した書面を乙に交付（FAXによる場合を含みます）し、乙がこれを承諾したときに成立するものとします。なお、乙が当該書面を受領後乙の7営業日以内に甲に対し受諾拒否の通知をしない場合は、個別契約が成立したものとみなします。\n2.        甲は、前項の書面をデジタルデータ化し、電気通信回線を通じ乙へ交付することにより、当該書面の交付に代えることができ、乙はこれを承諾します。',
                article_label: '個別契約の成立',
                one_phrase_comment: '確認：みなし成立',
                memo: '■リスク\nみなし成立の規定がある場合、受諾拒否の通知漏れがあった際に成立してしまうリスクあり。\n\n■対応\n①みなし規定の削除\n②みなし成立期間の延長',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: '',
                date_of_conclusion: '',
            },
            // article_label：個別契約の成立
            {
                article_id: 5,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '（個別契約）第二条',
                article_body: '1　業務の名称、概要・仕様、単価、代金総額、納期、引渡場所及び発注日等は、甲乙協議の上、個別契約で定めるものとする。\n2 　個別契約は、発注年月日、名称、仕様、単価、納期、納入場所その他について記載した甲所定の注文書を乙に交付（メール・FAX含む）し、乙がこれを承諾したときに成立する。',
                article_label: '個別契約の成立',
                one_phrase_comment: '必須：メール等簡易な方法での発注',
                memo: '■確認\n書面の押印、交付が必要となる場合、発注に時間と手間がかかる可能性があるため、簡易な方法での発注を定めること。\n発注書の書式の決定権が誰にあるかも確認。',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: 'D社',
                date_of_conclusion: '20190331',
            },
            // article_label：業務に関する責任
            {
                article_id: 6,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '第3条（本業務の責任）',
                article_body: '1　受託者は、本業務が請負型である場合は委託者が定める仕様に従い納入物を製作し納期までに納入するものとする。\n2　受託者は、本業務が準委任型である場合は委託者が定める仕様に従い善良な管理者の注意義務をもって本業務を遂行し、本業務が完了したときは業務完了報告書を委託者に提出するものとする。',
                article_label: '業務に関する責任',
                one_phrase_comment: '確認：本業務の型',
                memo: '■確認点\n本業務が請負型か準委任型かにより責任が変わるため注意。\n（事業部へ）責任を説明し実業務と合致しているか確認。',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: 'E社',
                date_of_conclusion: '20180616',
            },
            // article_label：業務に関する責任
            {
                article_id: 7,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '第2条　委託業務',
                article_body: '1．委託業務の詳細は個別契約で定めるものとする。\n2．委託業務は請負型とし、受託者は成果物の完成義務を負うものとする。',
                article_label: '業務に関する責任',
                one_phrase_comment: '委託業務の内容確認/請負型でOKか確認',
                memo: '■担当部署へ確認\n①委託業務の詳細を確認し、受託できる内容かどうか関連部門へ相談\n②書面上「請負」と記載しているが、準委任型や未定の場合は変更が必要なので確認。',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: '',
                date_of_conclusion: '',
            },
            // article_label：納入
            {
                article_id: 8,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '第6条（納入）',
                article_body: '1．乙は甲に対し、本件業務遂行の結果生じる成果物（以下、「本件成果物」という。）について、個別契約において定める納入期限までに、個別契約において定める場所及び方法により、当該成果物を納入するものとする。\n2．乙は、納期までに本件成果物の納入ができない恐れが生じた場合には、委託社に対し速やかに通知し、甲乙協議の上その取扱いを定めるものとする。\n3．本件成果物の所有権、知的財産権その他の権利は、次条の検査完了時に移転するものとする。',
                article_label: '納入',
                one_phrase_comment: '【第2案】納期遅延時の対応を追加（第2項）',
                memo: '■変更条件\n雛形に対し納入遅延時の対応の追加を要請された場合\n\n■趣旨\n納入遅延時の対応は、双方協議の上定める。\n先方が無理なスケジュールでの納入や莫大な賠償を請求する可能性があるため、「相手方の指示に従う」は不可。\n\n■可能となる対応\n減額（遅延日数％かつ10％まで）、賠償（納入遅延による直接損害に限ること）、契約解除（実施分の委託料は受領すること）。',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: 'F社',
                date_of_conclusion: '20190201',
            },
            // article_label：納入
            {
                article_id: 9,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '第6条（納入、および作業）',
                article_body: '１．甲は、個別契約で定められた期日、場所において本件業務を行う。\n２．甲が個別契約で定められた期日に本件業務を行えないことが判明した場合には、直ちに乙に対し書面（電磁的方法を含む）をもって通知する。この場合、甲は、乙が被った損害を、本契約に定める損害賠償の規定に基づき賠償しなければならない。',
                article_label: '納入',
                one_phrase_comment: '遅延時の損害賠償',
                memo: '■確認\n業務の遅延時に損害賠償の対応をする場合は、遅延に関して相手方に直接かつ現実的に生じた通常の損害（逸失利益を除く）を賠償の対象とすること。\n別条で損害賠償の規定がある場合はその内容を引用。',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: 'G社',
                date_of_conclusion: '20181106',
            },
            // article_label：納入
            {
                article_id: 10,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '第4条（納入）',
                article_body: '乙は、納期までに成果物を納入場所に納入するものとします。なお、乙は、納期前に成果物を甲へ納入するときは、予め甲の承諾を得るものとします。',
                article_label: '納入',
                one_phrase_comment: '確認：所有権移転の定めがないこと',
                memo: '■要変更\n所有権移転時期が「納入時」になっている場合は、検収完了時または代金完済時へ変更',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: '',
                date_of_conclusion: '',
            },
            // article_label：納入
            {
                article_id: 11,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '第6条（納入および終了報告）',
                article_body: '1.       受託者は、本業務を作業期間に行い、成果物がある場合は納期までに納入場所へ納入する。\n2.        受託者は、本業務が役務の提供を目的とするなど成果物の納入を伴わない場合、本業務が終了した場合には委託者に対し終了報告をするものとし、当該終了報告をもって本業務が完了したものとする。',
                article_label: '納入',
                one_phrase_comment: '確認：納入物がある場合/ない場合',
                memo: '■確認\n納入物がある場合、ない場合のどちらもが想定される場合、どちらの場合の規定も記載すること。',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: '',
                date_of_conclusion: '',
            },
            // article_label：成果物の検査
            {
                article_id: 12,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '第5条（検収）',
                article_body: '1.甲は、引渡しから10営業日以内（以下「検査期間」）に、当該本件成果物の検査を実施しなければならない。\n2.本件成果物が前項の検査に適合しない場合、乙は、書面（電子メール可）をもって、当該不適合の具体的な理由を明記して通知をしなければならない。\n3.前項の場合、甲と協議のうえ定めた期限内に修正して甲に納入し、甲は、検査期間において、所定の検査を再度行うものとする。なお、この場合、甲は乙が求める場合は不適合の根拠資料の開示に協力するものとする。',
                article_label: '成果物の検査',
                one_phrase_comment: '必須：不合格通知の具体的理由の明記',
                memo: '■不合格通知\n具体的理由の明示を必須にする\n\n■手当\n理由が不十分な場合に資料等を開示するよう義務付ける規定（3項なお書）を追加した',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: '',
                date_of_conclusion: '',
            },
            // article_label：成果物の検査
            {
                article_id: 13,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '第12条（成果物の検収）',
                article_body: '１ 甲は、引渡がなされた日から５営業日以内に、納入物が仕様に適合するかについて、検査を実施する。\n２ 甲は、納入物が前項の検査に適合する場合、合格通知を発送する。\n３ 甲が合格通知を送付しない場合であっても、検査期間内に甲が書面で具体的な理由を明示して異議を述べない場合には、納入物は、本条所定の検査に合格したものみなす。',
                article_label: '成果物の検査',
                one_phrase_comment: '必須：みなし合格の規定',
                memo: '■原則\nみなし合格の規定について、修正が入った場合は原則拒絶',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: 'H社',
                date_of_conclusion: '20181210',
            },
            // article_label：成果物の検査
            {
                article_id: 14,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '第10条（納入及び検査）',
                article_body: '１ 乙は甲に対し、個別契約で定める期日までに、個別契約に定める納入物を納入するものとする。\n２ 甲は、前条に従い納入物の納入がなされた日から３０日以内に、当該納入物が個別契約及び業務仕様書に定めた仕様に適合するか否かにつき、所定の方式により検査を実施する。\n３ 甲は、納入物が前項の検査に適合する場合、乙が指定する検収書を乙に交付するものとする。\n４ 甲が検収書を交付しない場合であっても、検査期間内に甲が書面で具体的な理由を明示して異議を述べない場合には、納入物は、本条所定の検査に合格したものみなす。',
                article_label: '成果物の検査',
                one_phrase_comment: '必須：受託者指定の検収書の交付',
                memo: '■原則\n検収書については当社指定のものを利用する\n\n■検収書の記載\n事業部に要確認',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: 'I社',
                date_of_conclusion: '20190720',
            },
            // article_label：成果物の検査
            {
                article_id: 15,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '第11条（納入物の検収）',
                article_body: '１ 甲は、前条に従い本件成果物の納入がなされた日から１４ 日以内に、本件成果物の本件仕様への合致の有無について確認する（以下「検収」という。）ものとする。\n２ 本件成果物が第１項の検収に適合しない場合、甲は、乙に対し、不合格の理由を書面、メールその他の方法により示して修正を求めるものとする。この甲の求めが正当であると乙が判断した場合、乙は、甲と協議のうえ定めた期限内に無償で修正して甲に納入し、甲は、第１項記載の検収期間において、所定の検収を再度行うものとする。\n３ 甲が検収書を交付しない場合であっても、第１項に定める検収期間内に甲が書面で具体的な理由を明示して異議を述べない場合には、本件成果物は、本条所定の検収に合格したものみなす。',
                article_label: '成果物の検査',
                one_phrase_comment: '原則：不合格理由の正当性判断は受託側',
                memo: '■原則\n不当な補修を求められないよう不合格理由については正当性要件を付加\n\n■交渉コメント\n不合格理由の判断には、専門知見も必要となるため当社判断も入れさせていただきます。',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: '',
                date_of_conclusion: '',
            },
            // article_label：危険負担
            {
                article_id: 16,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '第8条（危険負担）',
                article_body: '本件成果物の滅失、毀損等の危険負担は、甲による検収完了前については甲の責によるものを除き乙が、検収完了後については乙の責によるものを除き甲が、それぞれ負担する。',
                article_label: '危険負担',
                one_phrase_comment: '【第2案】検収完了基準で危険負担を移転',
                memo: '■変更条件\n先方の変更要望があった場合には、検収完了を基準としても可。\n■禁止\n代金完済前後での基準は不可。\n先方で十分使用しているにも関わらず代金の支払い時期が到来していないというだけで、当社が責任を負う必要が出てくるため。',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: 'J社',
                date_of_conclusion: '20191004',
            },
            // article_label：危険負担
            {
                article_id: 17,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '第2条 （危険負担）',
                article_body: '成果物がソフトウェアまたは有形物の場合、甲への納入後に生じた成果物の滅失、毀損、減量、変質、その他一切の損害は、受託者の責に帰すべきものを除いて、委託者の負担とします。',
                article_label: '危険負担',
                one_phrase_comment: '危険負担：納入基準',
                memo: '■確認ポイント\n①危険負担は納入基準\n②危険の内容を具体的に列挙',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: 'K社',
                date_of_conclusion: '20130930',
            },
            // article_label：瑕疵担保責任
            {
                article_id: 18,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '第9条（瑕疵担保責任）',
                article_body: '１ 本件成果物の検収完了後6か月以内に、検査では発見できなかった本件仕様との不一致（以下、「瑕疵」という。）が発見された場合、甲は乙に対して当該瑕疵の修正を請求することができる。\n２ 甲は、当該瑕疵により本契約および個別契約の目的が達成できない場合は、乙に対し自己に生じた損害の賠償を請求することができるものとする。ただし、当該損害は、当該瑕疵に起因して甲が直接被った損害に限るものとし、逸失利益は含まないものとする。\n３ 本件成果物の瑕疵が甲の指示又は甲が提供した資料等に起因する場合には、本条の規定は適用しない。',
                article_label: '瑕疵担保責任',
                one_phrase_comment: '【第2案】追加：相手方の損害賠償請求権',
                memo: '■変更条件\n・相手方より瑕疵の対応について損害賠償を求められた場合\n・かつ関係部署の部長承認を得られた場合\n\n■譲歩不可\n・損害賠償は「本契約および個別契約の目的を達成できないとき」のみ\n・賠償範囲は「逸失利益を含まない直接損害」のみ。',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: 'L社',
                date_of_conclusion: '20140301',
            },
            // article_label：瑕疵担保責任
            {
                article_id: 19,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '第7条（瑕疵担保責任）',
                article_body: '1．成果物の検査合格後6ヶ月以内に、成果物について、乙の責に帰すべき隠れた瑕疵が発見された場合は、乙の負担において速やかに瑕疵の修補を行うものとします。なお、乙が、成果物の瑕疵に関して甲に対して負う責任は、本条の定めに限られるものとします。\n2．本業務が機器の移動設置作業等の成果物を伴わない業務の場合には、乙は、乙の甲に対する本業務完了の報告と同時に瑕疵担保責任より免責されるものとします。',
                article_label: '瑕疵担保責任',
                one_phrase_comment: '確認：成果物がない場合の免責',
                memo: '■確認\n①瑕疵担保期間：6ヶ月\n②瑕疵の対応：修補のみ\n\n■要注意\n①瑕疵への対応は修補のみであることを明記\n②成果物の納入がない場合は瑕疵について免責される旨を明記',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: '',
                date_of_conclusion: '',
            },
            // article_label：瑕疵担保責任
            {
                article_id: 20,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '第12条　瑕疵担保責任について',
                article_body: '1.乙は、甲より成果物に瑕疵が存在する旨の通知を受けたときは、乙の責任と費用負担によりその瑕疵を修補する。なお、乙は、当該瑕疵に起因し甲に損害を与えた場合には、甲の被った損害を賠償するものとする。\n2.成果物の瑕疵担保期間は、甲による検査を完了した日から起算して12ヵ月とする。なお、当該瑕疵について、乙の故意または過失に起因する場合、または甲が重大な瑕疵であると判断した場合は、瑕疵担保期間の満了後も乙の責任において無償でこれを修補するものとする。',
                article_label: '瑕疵担保責任',
                one_phrase_comment: '注意：M社限定',
                memo: '■経緯\nM社との2001年5月1日付「業務委託基本契約書」においてこの内容で締結しているため、以後もM社限定で当社不利のこの内容で締結。\n定期的に変更を求めているが応じられず。\n実態として、瑕疵についての賠償請求はあるが、12ヶ月の瑕疵担保期間を超えて修補の請求を受けたことはこれまでなし。',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: 'M社',
                date_of_conclusion: '20010501',
            },
            // article_label：委託料
            {
                article_id: 21,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '第11条（支払）',
                article_body: '1.        委託者は、本件業務の代金を本契約末尾に記載の支払条件に従い、受託者へ支払うものとする。\n2.        前項の規定に関わらず、受託者が「下請代金支払遅延等防止法」に定める下請事業者に該当する場合には、委託者は、契約代金を同法の定めに従い受託者へ支払うものとする。\n3.        代金の支払に要する手数料は委託者の負担とする。',
                article_label: '委託料',
                one_phrase_comment: '確認：下請法対応',
                memo: '■事業部へ\n①契約書末尾の支払期日を必ず記載すること\n②受託業務の内容により当社が下請法対象会社になる場合は、同法に従った支払いとすることを明記',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: '',
                date_of_conclusion: '',
            },
            // article_label：委託料
            {
                article_id: 22,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '（代金および代金の支払）第10条',
                article_body: '1.甲から乙に対する代金の支払条件は、個別契約に定めるとおりとします。また、支払に要する手数料は甲の負担とします。\n2.乙は、甲より一旦受領した代金について、理由の如何を問わず甲へ返還しないものとします。\n3.個別契約の成立後、諸材料の価格、労務費、その他の経済情勢に変動が生じたとき、または、甲の要望による本業務の仕様等の変更もしくは追加をしたときは、乙は甲へ代金の変更を申し出ることができるものとし、その取り扱いについて甲乙協議するものとします。',
                article_label: '委託料',
                one_phrase_comment: '代金の返還なし/代金の変更可',
                memo: '■確認\n①代金前受けの際は、返還しない旨を記載\n②個別契約成立後であっても代金の変更の申し出可とする',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: 'N社',
                date_of_conclusion: '20190430',
            },
            // article_label：知的財産権等
            {
                article_id: 23,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '（知的財産権）第25条',
                article_body: '委託内容にかかる知的財産権の帰属は、甲乙協議の上決定するものとする。\n２　乙は、仕様書等に定める委託内容の履行ならびに成果物の使用等が第三者の知的財産権、肖像権その他の権利を侵害しないことを保証するものとする。\n３　甲は、委託内容に関して第三者から異議、苦情の申し出、または訴訟の提起等（以下「紛争」という。）を受けた場合には、速やかに乙に通知し、乙が紛争を解決するために必要となる権原を譲渡するものとする。これをもって、乙は、自己の責任と費用負担により、当該紛争を解決するものとする。\n４　乙は、仕様書等に知的財産権に関する特別の定めがある場合は、これに従うものとする。',
                article_label: '知的財産権等',
                one_phrase_comment: '確認：権利侵害時は自社で解決',
                memo: '■趣旨\n①権利の帰属は協議\n②権利侵害の恐れがある場合は自社が全て解決\n※相手方が主となって解決を図っても、業務の実施は自社なので相手方は詳細内容を把握しておらず、時間と費用がかかる恐れがあるため（過去事例：O社　2016年8月20日付け通知書参照）',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: '',
                date_of_conclusion: '',
            },
            // article_label：知的財産権等
            {
                article_id: 24,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '第13条（知的財産権等）',
                article_body: '1.        本業務遂行の過程で生じた発明、考案、意匠、著作物（著作権法第27条および第28条を含む）等の一切の知的財産権は、創出と同時に委託者に移転する。また、受託者は、委託者に対し著作物の著作権に基づく著作者人格権を行使しない。なお、当該移転の対価は、契約代金に含むものとする。\n2.        受託者は、成果物について、委託者の事前の書面による承諾を得ずに第三者へ販売し、または公表してはならない。\n3.        受託者は、成果物が第三者の有する特許権、商標権、著作権等の知的財産権に抵触しないことを委託者に保証する。\n4.        委託者および受託者は、成果物が第三者の知的財産権を侵害している旨の警告を受ける等の紛争が生じたときは、その旨を直ちに相手方に通知するものとする。この場合、受託者は、自己の責任と費用負担により当該紛争を処理解決するものとし、当該紛争に起因して委託者に損害を与えたときは、委託者の被った損害を賠償するものとする。なお、当該紛争が貸与品その他委託者の貸与した資料に起因する等委託者の責に帰すべき事由による場合には、受託者は責任を負わないものとする。',
                article_label: '知的財産権等',
                one_phrase_comment: 'P社案件限定：知的財産権を全て譲渡',
                memo: '■経緯\nQ社向けシステムにおいて当社が二次請で、委託元に権利を譲渡せざるを得なかったためこの内容で締結。\n一切の知的財産権を相手方に譲渡する場合は事業部長および該当の役員決済が必要。\n\n■注意\nQ社案件でなければ、P社との契約でも当社雛形の内容で問題なし。',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: 'P社',
                date_of_conclusion: '20170907',
            },
            // article_label：知的財産権等
            {
                article_id: 25,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '第１６条（産業財産権）',
                article_body: '１．本件業務に伴う発明、考案又は意匠の創作等（以下｢発明等｣という。）に係る特許権（又は特許を受ける権利）、実用新案権、意匠権等（以下｢特許権等｣という。）の帰属は、次のとおりとする。\n(１)甲が単独で行った発明等から生じた特許権等は、甲単独に帰属するものとする。\n(２)乙が単独で行った発明等から生じた特許権等は、乙単独に帰属するものとする。\n(３)甲及び乙が共同で行った発明等から生じた特許権等については次の通りとする。\n①甲及び乙の共有（持分は貢献度に応じて協議の上定める。）とする。\n②甲及び乙は、相手方の同意及び相手方への対価の支払いなしに、当該特許権等を自ら実施できる。\n③甲又は乙は、当該特許権等の実施を第三者に許諾するときは、相手方の事前の書面による同意を得るものとする。\n２．乙は、自己が従前より保有する特許権等を成果物に使用した場合、及び前項第２号により乙に帰属する特許権等が成果物に使用されている場合は、甲が自ら成果物を使用するために必要な範囲で、当該特許権等の実施を無償で甲に許諾するものとする。',
                article_label: '知的財産権等',
                one_phrase_comment: '単独発明、共同発明の詳細規定',
                memo: '■注意\n・単独発明、共同発明が想定される場合の規定。\n・相手方が仕様を切り当社が実施するのみの場合、当社が不利になる可能性あり。',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: 'R社',
                date_of_conclusion: '20191020',
            },
            // article_label：秘密保持義務
            {
                article_id: 26,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '第14条（秘密情報の取り扱い）',
                article_body: '1.        委託者および受託者は、本契約に関連して、相手方から秘密である旨を指定され開示を受けた書面、記録媒体、その他の情報（以下、秘密情報といいます）については、本条の定めに従い取り扱うものとします。なお、本条において、秘密情報を開示する当事者を開示者、開示者より秘密情報を受領する当事者を受領者といいます。\n2.        前項の規定は、次の各号に定める情報には適用しないものとします。\n(1)        公知の情報および開示後に受領者の責によらず公知となった情報。\n(2)        開示された時点で既に受領者が保有している情報。\n(3)        受領者が秘密情報によらず独自に創出した情報。\n(4)        正当な権限を有する第三者から秘密保持義務を負うことなく適法に入手した情報。\n3.        受領者は、秘密情報の秘密を保持し、開示者の事前の書面による承諾を得ずに、本契約の遂行の目的以外の目的に秘密情報を利用し、また、本契約の遂行に必要となる自己の役員および従業員以外の第三者に開示、提供してはならないものとします。なお、受領者は、当該役員および従業員ならびに開示者の承諾を得て開示する第三者に対し、本契約において自己が負う義務と同等の義務を課すものとします。\n4.        受領者は、本契約の遂行に必要な範囲を超えて秘密情報を複製してはならないものとします。なお、秘密情報を複製した場合には、秘密情報の複製物も秘密情報として取り扱うものとします。\n5.        受領者は、本契約が終了した場合、または開示者から要求があった場合には、その指示に従い、直ちに秘密情報（前項に基づき作成した複製物を含みます）を返還もしくは廃棄するものとします。\n6.        受領者は、開示者から開示された情報が秘密情報であるか否かに疑義があるときは、その取り扱いについて開示者と協議するものとします。\n7.        委託者および受託者は、本契約の履行に際して個人情報を取得した場合には、自らの責任により管理するものとします。\n8.        委託者および受託者は、本契約の履行に際して知り得た相手方の保有する個人情報を、法令、官公庁の定めるガイドラインに従い善良な管理者としての注意をもって取り扱うものとし、相手方の事前の承諾を得ずに、当該相手方より予め指定された利用目的以外の目的に利用し、または第三者に開示、漏洩してはならないものとします。\n9.        相手方の保有する個人情報を受領した一方当事者は、本契約が終了した場合または相手方より要請を受けた場合には、その相手方の指示に従い、直ちに個人情報を返還するものとします。',
                article_label: '秘密保持義務',
                one_phrase_comment: '【第2案】確認：個人情報を含む場合',
                memo: '■趣旨\n個人情報の開示・受領がある場合は本内容を使用。\n個人情報の取り扱いは法令等の定めによる。',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: '',
                date_of_conclusion: '',
            },
            // article_label：秘密保持義務
            {
                article_id: 27,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '16．秘密保持',
                article_body: '甲、および乙は、本契約期間中、ならびに本契約終了後5年間は、本契約、および個別契約において開示された相手方の情報について秘密を保持し、事前の書面による承諾なく第三者にこれらを開示しないものとする。ただし、開示された情報が次のいずれかに該当する場合を除く。\n（１）公知、または本契約に定める守秘義務に違反することなく公知となった事実\n（２）情報受領時に既に保有していた事実\n（３）第三者から守秘義務を負うことなく取得した事実\n（４）法令・規則・政府・裁判所、その他公的機関からの開示要請、または開示命令を受けた事実\n２．本契約、または個別契約が終了した場合、甲、および乙は、本契約、もしくは個別契約上得た相手方の秘密情報を相手方の指示に基づき返却、または廃棄し、以後使用しないものとする。ただし、法的手続における立証目的のみのために、相手方から受領した秘密情報の複製1部を自己の顧問弁護士の下で保管する場合は、この限りでない。\n',
                article_label: '秘密保持義務',
                one_phrase_comment: '確認：契約終了後も秘密情報の保持可',
                memo: '■必須\n契約終了後も秘密情報の保持を可とする場合、\n①保持目的\n②保管場所又は管理方法\nを必ず記載し、妥当性を検討すること。',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: 'S社',
                date_of_conclusion: '20131201',
            },
            // article_label：秘密保持義務
            {
                article_id: 28,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '（個人情報保護及び秘密の保持）第27条',
                article_body: '"甲及び乙は、法令、裁判所の決定若しくは命令又は行政官庁の要請による場合、弁護士、会計士、税理士その他の専門家に対し開示する場合、及び相手方の事前の書面による承諾を得た場合を除き、本契約に関して相手方から開示を受けた情報及び本契約に関連して知り得た相手方及び相手方の顧客の情報（以下、合わせて「秘密情報」という。）を善良な管理者の注意をもって厳重に管理し、秘密として保持し、情報の漏洩、不正アクセス、滅失又は毀損を防止するために必要かつ適切な措置を取らなければならない。ただし、次の各号の情報は、個人情報を除き秘密情報とならないものとする。\n（1）相手方から開示された時点で公知である情報\n（2）相手方から開示された後、自己の責めによらず公知となった情報\n（3）第三者から機密保持義務を負うことなく合法的に入手した情報\n（4）相手方から開示された情報によることなく独自に開発した情報\n２　甲及び乙は、秘密情報を本契約の恥垢の目的以外には利用してはならない。\n３　甲及び乙は、秘密情報を盗用・改竄し、又は第三者に開示・漏洩してはならない。\n４　甲及び乙は、秘密情報を複製してはならない。\n５　甲及び乙は、自己の役員又は従業者であっても、本契約の履行のために必要のない者に対し秘密情報を開示してはならない。\n６　甲及び乙は本契約の内容を第三者に再委託する場合は、当該再委託崎に対し本条の規定を遵守させなければならない。\n７　甲及び乙は、自己又は自己の役員及び従業員、再委託先が本条の定めに違反し相手方に損害を与えた場合には、その損害を賠償しなければならない。\n８　甲及び乙は、本契約終了後、相手方の求めに応じ。秘密情報の全てを相手方に返還するか、又は相手方の指定する方法でこれらを廃棄又は消去し、その旨の証明書を相手方に交付するものとする。\n９　本条の規定は、本契約終了後においても有効に存続する。',
                article_label: '秘密保持義務',
                one_phrase_comment: 'T社限定',
                memo: '■確認\n①相互義務になっているかどうか\n②実務上実施可能かどうか\n\n■注意\n①T社提示の雛形は当社義務のみになっている場合があるので要注意\n②複製禁止なので、実務上複製が必要であれば交渉する\n③廃棄、消去等の証明書の提出が必要なので実務上可能かどうか確認する',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: 'T社',
                date_of_conclusion: '20190121',
            },
            // article_label：再委託
            {
                article_id: 29,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '第13条（再委託）',
                article_body: '乙は、本件業務の遂行に必要となる場合、甲の事前の書面による承諾を得ることにより、本件業務の全部又は一部を第三者に再委託することができる。この場合、乙は、当該第三者の選任及び監督につき、甲に対して責任を負う。',
                article_label: '再委託',
                one_phrase_comment: '【第2案】相手方の事前承諾を得る場合',
                memo: '■確認\n相手方より事前承諾を得るよう求められた場合は本条を使用。',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: '',
                date_of_conclusion: '',
            },
            // article_label：再委託
            {
                article_id: 30,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '第17条　再委託',
                article_body: '乙は、本契約において自己の負う義務と同等の義務を課すことを条件として、本業務の全部または一部を第三者に再委託できるものとする。',
                article_label: '再委託',
                one_phrase_comment: '自社有利',
                memo: '■概要\n①相手方の事前承諾不要\n②本契約と同等の義務を課すことを条件\n③再委託した場合の責任明記なし',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: 'U社',
                date_of_conclusion: '20191110',
            },
            // article_label：再委託
            {
                article_id: 31,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '（再委託）第5条',
                article_body: '１．甲は、本件業務の全部、または一部を甲の責任において第三者に再委託することができる。\n２．甲は、自己の子会社、関連会社以外の第三者に本件業務を再委託する場合、事前に再委託する旨、および再委託先の情報を乙に報告しなければならない。\n３．甲は、再委託先の履行について乙、および乙の顧客に帰責理由がある場合を除き、自ら業務を遂行した場合と同様の責任を負うものとする。\n４．前項の場合、甲は当該再委託先に対して本契約に定める反社会的勢力の排除、損害賠償、秘密保持、および協力事項の条項と同様の義務を負わせなければならない。',
                article_label: '再委託',
                one_phrase_comment: '確認：自己の関連会社への再委託は通知なし',
                memo: '■確認\n自己の子会社、関連会社への再委託が想定される場合、それらへの再委託は通知不要、相手方の事前承諾不要とする。\n■過去事例\n反復的に再委託が必要となるにも関わらず、相手方の事前承諾が必須だったため、毎回承諾を得る手間が発生した。（V社）',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: 'W社',
                date_of_conclusion: '20181001',
            },
            // article_label：解除
            {
                article_id: 32,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '第17条（解除）',
                article_body: '甲および乙は、自らが次の各号の一つに該当した場合には、その相手方からの通知催告等がなくても当然に期限の利益を失うものとし、相手方に対する債務の全額を直ちに弁済するものとする。なお、甲または乙は、その相手方が次の各号の一つに該当したときは、本契約の全部または一部を解除できるものとする。\n(1)本契約に違反したとき。\n(2)正当な理由なく、期限内に本契約を履行する見込みがないと認められるとき。\n(3)災害その他、やむを得ぬ事情により本契約の履行が困難と認められたとき。\n(4)破産手続開始、民事再生手続開始または会社更生手続開始の申立てを受け、もしくは申立てをし、または清算手続に入ったとき。\n(5)支払の停止（1回のみの手形または小切手の不渡りを含む）があったとき、または手形交換所もしくは金融機関から取引停止処分を受けたとき。\n(6)差押え、仮差押え、仮処分もしく競売の申立てがあり、または租税公課の滞納処分を受けたとき。\n(7)関係官庁から営業の許可取消処分または停止処分を受けたとき。\n(8)解散を決議し、または他の会社に吸収されたとき。\n(9)相手方または第三者に対する債務の履行猶予の申出、債権者集会の招集準備または主要資産の処分の準備その他債務の履行が困難と認められる事由が生じたとき。',
                article_label: '解除',
                one_phrase_comment: '必須：期限の利益の喪失',
                memo: '■確認\n違反者の期限の利益の喪失を必ず明記すること（別条でも可）。\n\n■事業部へ連絡事項\n本契約違反を無催告解除とするか催告解除とするかは事業部判断。\n・相手方との取引継続期間\n・相手方との取引金額\n・与信\n等を元にすること。',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: '',
                date_of_conclusion: '',
            },
            // article_label：解除
            {
                article_id: 33,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '第12条　契約解除',
                article_body: '１．契約当事者が次の各号のいずれかに該当する場合には、なんらの催告を要することなく本契約を直ちに解除することができる。\n（１）本契約、または個別契約のいずれかに違反した場合\n（２）支払停止、または支払不能に陥った場合\n（３）自ら振り出し、または裏書した手形、および小切手の不渡りを１回でも出した場合\n（４）差押え・仮差押え・仮処分・競売の申立て・公租公課の滞納処分、その他公権力の処分を受けた場合\n（５）破産手続開始・民事再生手続開始・会社更生手続開始、または特別清算開始の申立てを受け、もしくは申立てをなした場合、または特定調停の申立てをなした場合\n（６）解散・事業の全部、または重要な部分の譲渡決議をした場合\n（７）事業を廃止した場合\n（８）監督官庁より事業停止命令を受け、または事業に必要な許認可の取消処分を受けた場合\n（９）株主構成、および役員の変動等により会社の実質的支配関係が変化し、従前の会社との同一性が失われた場合\n（10）その他前各号に準じる事由が生じた場合\n２．前項の場合に当事者に損害が生じた場合には、相手方は、それを賠償しなければならない。\n３．本条第１項のいずれかに該当する事由が生じた場合、甲は、本契約、または他の契約に基づき乙に対して有する債権と本件業務の代金債権を対当額において相殺することができる。\n４．本条第１項各号にかかわらず、甲の本件業務遂行において問題が生じた場合、乙は、甲に対して改善を求めるものとする。甲の改善が実施されないと乙が判断した場合、乙は、甲に書面にて告知することにより中途契約解除することができる。',
                article_label: '解除',
                one_phrase_comment: 'X社限定：解除事由に該当しない場合の中途解約権',
                memo: '■注意\n解除事由に該当しない場合であっても、\n①相手方が業務遂行に改善を求めることができる\n②改善されないと判断された場合は中途解約できる\n契約違反を含めた解除事由に該当しない場合であっても解除される恐れがあるので注意。',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: 'X社',
                date_of_conclusion: '20170324',
            },
            // article_label：不可抗力
            {
                article_id: 34,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '第16条（免責）',
                article_body: '1.        受託者は、天災地変（地震、水害、落雷等）停電等の不可抗力により、本契約の履行に遅延または履行不能の事態が生じた場合は、委託者に対しその責任を一切負わないものとする。\n2.        委託者は、本業務を委託するために受託者へ提供する情報について、その正確性、適法性、妥当性、完全性、第三者の権利侵害の有無等の検証と確認を自己の責任と費用負担にて実施、使用するものとし、受託者は、当該検証および確認に関して何らの責任を負わないものとする。',
                article_label: '不可抗力',
                one_phrase_comment: '確認：不可抗力＋相手方の責によるものの免責',
                memo: '■確認\n①不可抗力の列挙に過不足がないか確認。\n②相手方から提供を受ける情報の誤りについては免責。',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: 'Y社',
                date_of_conclusion: '20191201',
            },
            // article_label：不可抗力
            {
                article_id: 35,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '不可抗力　第二十条',
                article_body: '甲及び乙は、次の不可抗力が発生した場合には、相手方に対し責任を負わないものとする。ただし、金銭債務は除くものとする。\n（1）地震、水害、落雷、停電等\n（2）戦争、暴動、内乱等\n（3）ストライキ、労働紛争等\n（4）政府、地方公共団体の命令、法令等の改正\n（5）通信回線の切断、輸送機関の事故等\n（6）再委託先、又は仕入元の破綻、不履行',
                article_label: '不可抗力',
                one_phrase_comment: '確認：過不足（なるべく広めに）',
                memo: '■確認\n過不足がないか確認。\n相手方にも金銭以外の債務がある場合、第4号以下は削除を検討する。\n（4）は通常事前の周知や経過措置があるため。\n（5）は代替手段がある場合、補償や保険がある場合があるため。\n（6）も補償がある場合があるため。',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: 'Z社',
                date_of_conclusion: '20160421',
            },
            // article_label：損害賠償
            {
                article_id: 36,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '第16条（損害賠償）',
                article_body: '甲及び乙は、本契約に基づき又は関連して、相手方の責に帰すべき事由により損害を被った場合、相手方に対し、現実に生じた直接かつ通常の範囲の損害（弁護士費用その他専門家費用及び逸失利益を除く。）の賠償を請求することができる。なお、当該賠償額は、当該賠償の原因を生じさせた個別契約において定めた委託報酬額の3倍を上限とする。',
                article_label: '損害賠償',
                one_phrase_comment: '【第2案】金額上限を3倍に',
                memo: '■変更条件\n単価の安価な契約の場合、相手方より委託報酬額上限では受け入れられないので変更可。\nただし次の条件つき。\n・相手方より損賠額上限を上げる要求がある。\n・単価が最大で2万円以下。\n・事業部長の決済済み。\n・法務部長の決済済み。',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: 'A社',
                date_of_conclusion: '201502010',
            },
            // article_label：損害賠償
            {
                article_id: 37,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '第19条（損害賠償）',
                article_body: '本契約の他の条項に規定するもののほか、委託者および受託者は、その相手方が本契約に違反したことにより損害を被った場合は、本契約に定める契約代金を上限として、自らに直接かつ現実的に生じた損害（逸失利益を除く）の賠償を相手方に請求することができるものとする。',
                article_label: '損害賠償',
                one_phrase_comment: '必須：直接損害、契約金額上限、逸失利益の除外',
                memo: '■確認\n①賠償範囲は直接損害に限定すること。\n②賠償額は契約金額を上限とすること。\n③損害の中から逸失利益を除くことを明記すること。',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: '',
                date_of_conclusion: '',
            },
            // article_label：損害賠償
            {
                article_id: 38,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '第23条　損害賠償に関する規定',
                article_body: '乙は、本契約または個別契約に違反したことにより甲に対し損害を与えた場合は、甲に生じた一切の損害の賠償するものとする。',
                article_label: '損害賠償',
                one_phrase_comment: 'B社限定',
                memo: '■確認\nB社限定で本規程を使用。\n当社のみの義務だが、B社が賠償をする場合は法に基づくので双務にする必要はなし。\n\n■注意\n初回は当社雛形の案を提示すること。',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: 'B社',
                date_of_conclusion: '20060925',
            },
            // article_label：権利譲渡の制限
            {
                article_id: 39,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '第15条（譲渡禁止）',
                article_body: '甲、および乙は、本契約上の地位、または本契約から生じる一切の権利義務について相手方の事前の書面による承諾なくして第三者に譲渡してはならない。',
                article_label: '権利譲渡の制限',
                one_phrase_comment: '必須：双方義務、事前承諾',
                memo: '■趣旨\n権利を譲渡する場合は、双方とも相手方の承諾を必須とする。',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: '',
                date_of_conclusion: '',
            },
            // article_label：権利譲渡の制限
            {
                article_id: 40,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '（権利の譲渡等）第15条',
                article_body: '1.        委託者及び受託者は、相手方の事前の書面による承諾を得ずに、次の行為を行ってはならないものとします。\n(1)        本契約に基づく債務の全部又は一部を第三者に履行させること。\n(2)        本契約に基づく金銭債権その他の債権の全部又はその一部を第三者に譲渡し、担保に供し、又はその他の処分をすること。\n2.        前項の規定に関わらず、受託者は、本契約において自己の負う義務と同等の義務を課すことを条件として、本契約の履行の全部又は一部を第三者に再委託できるものとします。',
                article_label: '権利譲渡の制限',
                one_phrase_comment: '確認：第三者委託',
                memo: '■確認\n①相手方の書面承諾を得た上での履行、譲渡、担保又は処分\n②第三者委託可\n■趣旨\n第1項1号に「第三者に履行させること」が含まれるため、第2項で再委託を追加した。',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: 'D社',
                date_of_conclusion: '20170510',
            },
            // article_label：契約期間
            {
                article_id: 41,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '第20条 （有効期間）',
                article_body: '本契約の有効期間は、本契約締結の日から〇〇年〇〇月〇〇日までとする。なお、甲乙協議の上有効期間を短縮又は延長することができるものとする。',
                article_label: '契約期間',
                one_phrase_comment: '確認：期間の妥当性',
                memo: '■確認\n①有効期間が妥当かどうか確認\n②協議により短縮、延長を可（記載なしも可）\n\n■手続き\n①有効期間を遡る場合は、「本契約締結の日」を具体的な日付に書き換える。契約締結美の遡求は禁止。\n②契約期間を短縮又は延長する場合は、覚書の取得必須。',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: '',
                date_of_conclusion: '',
            },
            // article_label：契約期間
            {
                article_id: 42,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '第24条（有効期間）',
                article_body: '1.        本契約の有効期間は、本契約の締結日から1年間とする。なお、期間満了の1ヶ月前までにいずれの当事者から何らの通知がないときは、本契約と同一の条件により1年間更新し、以後も同様とする。\n2.        前項の規定により、本契約が期間満了により終了したときであっても、なお有効な個別契約が存在するときは、当該個別契約を履行する範囲において、本契約の定めは有効とする。',
                article_label: '契約期間',
                one_phrase_comment: '必須：個別契約の取り扱い',
                memo: '■確認\n本契約が終了した場合の個別契約の取り扱いを定めること。',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: '',
                date_of_conclusion: '',
            },
            // article_label：契約期間
            {
                article_id: 43,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '第10条　契約期間',
                article_body: '本契約は〇〇年〇〇月〇〇日より１年間効力を有する。契約期間満了3ヶ月以上前までに契約当事者が書面をもって相手方に対し、本契約を更新しない旨の意思表示をしない限り、本契約は自動的に１年間延長されるものとし、以後も同様とする。ただし、甲が乙の専属の業務委託先ではないことを甲乙共に認知している場合は、上記期限を1ヶ月以上前とすることができる。',
                article_label: '契約期間',
                one_phrase_comment: '確認：事前通知期間',
                memo: '■確認\n事前通知期間に２種あるので注意。\n契約時点で事業部に状況を確認すること。',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: 'E社',
                date_of_conclusion: '20190810',
            },
            // article_label：契約期間
            {
                article_id: 44,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '第21条（契約期間）',
                article_body: '本契約は、第8条に定める委託料が委託者から受託者へ完済されたときをもって終了する。',
                article_label: '契約期間',
                one_phrase_comment: '確認：別条の記載',
                memo: '■確認\n締結前に具体的にいつになるか確認（担当者、経理）。\n支払サイトが長い場合は要検討。',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: 'F社',
                date_of_conclusion: '20181201',
            },
            // article_label：存続条項
            {
                article_id: 45,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '第18条（存続）',
                article_body: '本契約の有効期間満了または本契約の解除等により本契約が終了した場合でも、第10条、第11条、第12条、第13条、本条、第19条および第21条の規定はなお5年間有効とする。',
                article_label: '存続条項',
                one_phrase_comment: '存続期間5年',
                memo: '■確認\n存続条項全てが契約終了後5年で終了。\n損害賠償、合意管轄等5年以降も存続すべきものが含まれる場合は変更。',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: 'G社',
                date_of_conclusion: '20170317',
            },
            // article_label：存続条項
            {
                article_id: 46,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '第17条　存続条項',
                article_body: '本契約の有効期間満了または本契約の解除等により本契約が終了した場合でも、第7条、第12条乃至第15条、第21条乃至第23条、本条本項および第26条の規定はなお有効とする。',
                article_label: '存続条項',
                one_phrase_comment: '存続期間なし',
                memo: '■事業部へ確認\n存続期間の定めがない場合、永久に存続することとなるので次の確認を取る。\n・秘密情報の取り扱いが永久となるので実務上管理が可能かどうか。\n・保証規定が永久に存続しても問題ない内容かどうか。\n・瑕疵担保期間の定めがあるかどうか（期間の定めがあれば、存続条項に含まれていても問題なし）。',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: 'H社',
                date_of_conclusion: '20170118',
            },
            // article_label：管轄裁判所
            {
                article_id: 47,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '第20条（管轄裁判所）',
                article_body: '本契約に起因し又は関連する一切の紛争については、その訴額に応じ、被告となる当事者の本社所在地を管轄する地方裁判所又は東京簡易裁判所を第一審の合意管轄裁判所とする。',
                article_label: '管轄裁判所',
                one_phrase_comment: '【第2案】被告裁判籍',
                memo: '■趣旨\n原則は、合意管轄は自社本社のある東京とすること。\n相手方から変更要求があった場合、受託者である自社が被告となる可能性が高いので、「被告となる当事者の本社所在地を管轄する地方裁判所」でも可。\nこの場合、顧問弁護士の出張費用等は事業部負担となるので事業部長の承諾を得ること。',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: '',
                date_of_conclusion: '',
            },
            // article_label：管轄裁判所
            {
                article_id: 48,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '第18条',
                article_body: '本契約、および個別契約における一切の紛争について、甲、および乙は、被告となる当事者の本社所在地の地方裁判所を合意管轄裁判所とする。',
                article_label: '管轄裁判所',
                one_phrase_comment: '被告裁判籍',
                memo: '■経緯\n相手方で東京地裁を受け入れられなかったため被告裁判籍。\n相手方本社が名古屋のため、〇〇事業部へ確認、承諾を得た上で被告裁判籍にて合意。',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: 'I社',
                date_of_conclusion: '20190108',
            },
            // article_label：協議
            {
                article_id: 49,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '第19条（疑義の解釈）',
                article_body: '本契約の定めのない事項、その他本契約に生じた疑義については、甲乙誠意をもって協議のうえ、決定するものとする。',
                article_label: '協議',
                one_phrase_comment: '協議不調の定めに注意',
                memo: '■趣旨\n協議が調わなかった場合の定めがある場合は要確認。\n解除の定めがある場合が多いが、解除権が相手方のみとなる場合や仕掛品の納入が定められている場合は削除。',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: 'J社',
                date_of_conclusion: '20160409',
            },
            // article_label：協議
            {
                article_id: 50,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '（協議解決）第23条',
                article_body: '本契約に定めのない事項および疑義のある事項は、甲乙協議して解決するものとします。',
                article_label: '協議',
                one_phrase_comment: '協議不調の定めに注意',
                memo: '■趣旨\n協議が調わなかった場合の定めがある場合は要確認。\n解除の定めがある場合が多いが、解除権が相手方のみとなる場合や仕掛品の納入が定められている場合は削除。',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: 'K社',
                date_of_conclusion: '20191004',
            },
            // article_label：協議
            {
                article_id: 51,
                index: 'disp_gva_sample',
                contract_id: 24,
                sort_order: 2,
                article_title: '第30条　紛争の解決',
                article_body: '委託者及び受託者は、本契約の履行に関し、紛争又は疑義が生じた場合には、その都度協議して円満に解決するものとする。',
                article_label: '協議',
                one_phrase_comment: '協議不調の定めに注意',
                memo: '■趣旨\n協議が調わなかった場合の定めがある場合は要確認。\n解除の定めがある場合が多いが、解除権が相手方のみとなる場合や仕掛品の納入が定められている場合は削除。',
                related_documents: [],
                option_articles: [],
                check_required_flg: false,
                delete_required_flg: false,
                supplier_name: 'L社',
                date_of_conclusion: '20191101',
            },
        ],
    },
});
